import { theme } from '@approvalmax/theme';
import { Link } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const EmailLink = styled(Link)`
    width: 100%;
    height: 100px;
    border-radius: ${theme.radius.xsmall};
    border: 1px solid ${theme.color.blue80};
    transition: ${theme.duration.medium}ms;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    &,
    &:hover,
    &:focus {
        color: ${theme.color.midnight80};
        text-decoration: none;
    }

    &:hover,
    &:focus {
        background-color: ${theme.color.blue10};
    }
`;
